<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { tchMarked } from "@common/Common";
    import { AttributeDescriptionDialogViewModel } from "@Alternatives/Attributes/Components/AttributeDescriptionDialog";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class AttributeDescriptionDialog extends Vue
    {
        get vm(): AttributeDescriptionDialogViewModel { return this.$props.viewModel as AttributeDescriptionDialogViewModel; }

        get opened(): boolean { return this.vm?.opened; }

        get name(): string { return this.vm.name; }
        get description(): string | null { return this.vm.description; }
        get descriptionHtml(): string | null { return tchMarked(this.vm.description); }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{name}}</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p v-if="!description" class="text-muted font-italic lead">No description provided</p>
                        <div v-html="descriptionHtml"></div>
                    </div>
                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>